import { render, staticRenderFns } from "./SeeDetails.vue?vue&type=template&id=70ce503e&scoped=true&"
import script from "./SeeDetails.vue?vue&type=script&lang=ts&"
export * from "./SeeDetails.vue?vue&type=script&lang=ts&"
import style0 from "./SeeDetails.vue?vue&type=style&index=0&id=70ce503e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ce503e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VDialog})
